import { Mail, Lock, Smartphone } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { useAuthStore } from '@/features/auth/store/auth-store'
import { LoginEmailCodeForm } from './login-email-code'
import { LoginEmailPasswordForm } from './login-email-password'
import { OtpPhoneLoginForm } from './login-phone-code'

export function LoginForm() {
  const { loginMode, setLoginMode, setView } = useAuthStore((s) => s.authView)

  const renderContent = () => {
    switch (loginMode) {
      case 'phone-code':
        return (
          <>
            <div className='flex flex-col items-center gap-2 text-center'>
              <h1 className='text-foreground text-2xl font-semibold tracking-tight'>
                手机验证码登录
              </h1>
              <p className='text-muted-foreground text-sm'>
                未注册的手机号验证通过后将自动注册
              </p>
            </div>
            <OtpPhoneLoginForm />
          </>
        )
      case 'email-code':
        return (
          <>
            <div className='flex flex-col items-center gap-2 text-center'>
              <h1 className='text-foreground text-2xl font-semibold tracking-tight'>
                邮箱验证码登录
              </h1>
              <p className='text-muted-foreground text-sm'>
                通过邮箱验证码极速登录
              </p>
            </div>
            <LoginEmailCodeForm />
          </>
        )
      case 'email-password':
        return (
          <>
            <div className='flex flex-col items-center gap-2 text-center'>
              <h1 className='text-foreground text-2xl font-semibold tracking-tight'>
                账号密码登录
              </h1>
              <p className='text-muted-foreground text-sm'>
                请输入您的邮箱和密码进行登录
              </p>
            </div>
            <LoginEmailPasswordForm />
          </>
        )
    }
  }

  return (
    <div className='flex flex-col gap-6'>
      {renderContent()}

      <div className='relative'>
        <div className='absolute inset-0 flex items-center'>
          <span className='w-full border-t' />
        </div>
        <div className='relative flex justify-center text-xs uppercase'>
          <span className='bg-card text-muted-foreground px-2'>
            Or continue with
          </span>
        </div>
      </div>

      <div className='flex flex-col gap-2'>
        {loginMode !== 'phone-code' && (
          <Button
            variant='outline'
            className='h-12 w-full'
            onClick={() => setLoginMode('phone-code')}
          >
            <Smartphone className='mr-2 h-4 w-4' /> 手机验证码登录
          </Button>
        )}
        {loginMode !== 'email-password' && (
          <Button
            variant='outline'
            className='h-12 w-full'
            onClick={() => setLoginMode('email-password')}
          >
            <Lock className='mr-2 h-4 w-4' /> 邮箱密码登录
          </Button>
        )}
        {loginMode !== 'email-code' && (
          <Button
            variant='outline'
            className='h-12 w-full'
            onClick={() => setLoginMode('email-code')}
          >
            <Mail className='mr-2 h-4 w-4' /> 邮箱验证码登录
          </Button>
        )}
      </div>

      <div className='text-muted-foreground text-center text-sm'>
        还没有账号？{' '}
        <Button
          variant='link'
          className='text-primary p-0 hover:underline'
          onClick={() => setView('register')}
        >
          立即注册
        </Button>
      </div>
    </div>
  )
}
